// #ux-redesign-start: LaboratoryStudies rediseñada (Paso 5 — Patients)
// Reemplaza Card>CardBody anidados + nav pills legacy por PageContainer +
// Tabs del DS. Mantiene los hijos (StudiesList + HistoryList) intactos.
// LoadingLocal → LoadingBlock. Theme-aware.
// ─────────────────────────────────────────────────────────────────────────────

import React, { useEffect, useState } from "react";
import { useTranslate } from "react-translate";

import { PageContainer, Tabs, LoadingBlock } from "components/ds";
import StudiesList from "components/Laboratories/StudiesList";
import HistoryList from "components/Laboratories/HistoryList";

const LaboratoryStudies = () => {
  const [consent, setConsent] = useState("loading");
  const [activeTab, setActiveTab] = useState("studies");
  const t = useTranslate("laboratory-studies");

  useEffect(() => {
    setConsent(true);
  }, []);

  const tabs = [
    { key: "studies", label: t("my-studies") },
    { key: "history", label: t("history") },
  ];

  return (
    <PageContainer title={t("laboratory-studies")} icon="microscope">
      {consent === "loading" ? (
        <LoadingBlock />
      ) : (
        <>
          <Tabs
            tabs={tabs}
            value={activeTab}
            onChange={setActiveTab}
            ariaLabel={t("laboratory-studies")}
          />
          <div style={{ marginTop: "var(--space-4)" }}>
            {activeTab === "studies" && <StudiesList />}
            {activeTab === "history" && <HistoryList />}
          </div>
        </>
      )}
    </PageContainer>
  );
};

export default LaboratoryStudies;
// #ux-redesign-end
